export enum FeatureEntitlements {
  LifecycleCRM = 'whitelabel_lifecycle_crm',
  TargetingApiSegmentTooling = 'targeting_api_segment',
  MultiBannerSfpCampaignAndSegment = 'multi_banner_sfp_campaign_and_segment',
}
